import { render, staticRenderFns } from "./SendTemplatesTable.vue?vue&type=template&id=65769528&scoped=true&"
import script from "./SendTemplatesTable.vue?vue&type=script&lang=js&"
export * from "./SendTemplatesTable.vue?vue&type=script&lang=js&"
import style0 from "./SendTemplatesTable.vue?vue&type=style&index=0&id=65769528&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65769528",
  null
  
)

export default component.exports